// extracted by mini-css-extract-plugin
export default {"ExitAccount":"ExitAccount_ExitAccount__RRXCV","ExitAccountImg":"ExitAccount_ExitAccountImg__tTrmV","ExitAccountButton":"ExitAccount_ExitAccountButton__av9pl"};